import styles from './MeasureOneKicker.module.css'
import { Spinner } from '@/components/Spinner'

export function MeasureOneSpinner() {
  return (
    <div className={styles.spinner}>
      <Spinner />
    </div>
  )
}
